import httpCommon, { httpFormData } from "./http-common";

// Get all signatures for a business
const getAllSignatures = (businessId: number) => {
  return httpCommon.get(`/v1/get/userSignaturesByBusiness/${businessId}`);
};

const getAllSignaturesForSelf = () => {
  return httpCommon.get(`/v1/get/userSignatures`);
};

// Get signature by ID
const getSignature = (signatureId: string) => {
  return httpCommon.get(`/v1/get/userSignature/${signatureId}`);
};

// Create signature
const createSignature = (data: any, onUploadProgress?: (progressEvent: ProgressEvent) => void) => {
  // Check if data contains files and should use form-data
  if (data instanceof FormData) {
    return httpFormData.post(`/v1/add/userSignature`, data, {
      onUploadProgress: onUploadProgress ? (progressEvent: any) => onUploadProgress(progressEvent) : undefined
    });
  }
  return httpCommon.post(`/v1/add/userSignature`, data);
};

// Update signature
const updateSignature = (signatureId: string, data: any, onUploadProgress?: (progressEvent: ProgressEvent) => void) => {
  // Check if data contains files and should use form-data
  if (data instanceof FormData) {
    return httpFormData.put(`/v1/update/userSignature/${signatureId}`, data, {
      onUploadProgress: onUploadProgress ? (progressEvent: any) => onUploadProgress(progressEvent) : undefined
    });
  }
  return httpCommon.put(`/v1/update/userSignature/${signatureId}`, data);
};

// Delete signature
const deleteSignature = (signatureId: string) => {
  return httpCommon.delete(`/v1/delete/userSignature/${signatureId}`);
};

// Set signature as default
const setDefaultSignature = (signatureId: string) => {
  return httpCommon.put(`/v1/update/userSignature/${signatureId}`, { isDefault: true });
};

const SignatureService = {
  getAllSignatures,
  getAllSignaturesForSelf,
  getSignature,
  createSignature,
  updateSignature,
  deleteSignature,
  setDefaultSignature
};

export default SignatureService; 